import { ApiTimeoutError } from './appErrors';

const DEFAULT_TIMEOUTS = {
  // Misurato sul motore (1/09/2026, carico zero): 31,5 s per 83k caratteri,
  // 45 s per 500k, 149 s per 3.000.000, che e' il tetto del browser da quando
  // REACT_APP_MAX_DOCUMENT_CHARS sta a 3M nelle build. Il vecchio budget di
  // 300 s ne lasciava il doppio scarso su un motore a riposo: bastava un po'
  // di coda per chiudere la richiesta a meta' e far vedere un errore mentre
  // il server continuava a generare, e a pagare. 600 s tiene un margine 4x
  // sulla misura e resta ben sotto i 1800 s che Cloud Run concede alla
  // richiesta: un tetto ONESTO, non uno che si spera di non toccare.
  '/process-document': 600000,
  // L'accettatore della coda risponde 202 in millisecondi: se non lo fa in
  // un minuto e' giu', e ha senso ripiegare sul percorso sincrono.
  '/process-document-streaming': 60000,
  '/get-feedback': 60000,       // 60 seconds
  '/transcribe-audio': 30000,   // 30 seconds
  '/generate-podcast': 300000,  // 5 minutes (multi-host TTS can take 2-4 min)
  // Il piano episodi e' un giro di LLM su TUTTO il testo del documento: su un
  // PDF da centomila battute non rientra in 30 secondi. Mancando questa riga
  // cadeva sul default, e la ricerca e' per chiave ESATTA — '/generate-podcast'
  // qui sopra non copre '/generate-podcast-outline'. Effetto: la generazione
  // automatica del podcast si interrompeva prima ancora di cominciare, e
  // l'unico segno era una riga in console.
  '/generate-podcast-outline': 180000,  // 3 minuti
  // Il piano di un documento gia' caricato (STU-457): un giro del planner sul
  // testo INTERO, che lato server ha fino a 600 s (timeout_manager.py,
  // planintelligente). Stesso tetto: chiudere prima vorrebbe dire dire
  // "non riuscito" a un piano che intanto arriva nel calendario.
  '/api/generate-study-plan': 600000,
  default: 30000                // 30 seconds
};

/**
 * Wraps an axios call with a timeout using AbortController.
 * Actually cancels the HTTP request on timeout (frees browser connection slot).
 *
 * @param {Function} axiosCallFn - Receives { signal } and returns an axios promise
 * @param {string} endpoint - Endpoint name (for timeout lookup and error context)
 * @param {number} [customTimeoutMs] - Override the default timeout
 * @returns {Promise} The axios response
 * @throws {ApiTimeoutError} If the request exceeds the timeout
 */
export const withTimeout = async (axiosCallFn, endpoint, customTimeoutMs) => {
  const timeoutMs = customTimeoutMs || DEFAULT_TIMEOUTS[endpoint] || DEFAULT_TIMEOUTS.default;
  const controller = new AbortController();

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeoutMs);

  try {
    const result = await axiosCallFn({ signal: controller.signal });
    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED' || error.message?.includes('aborted')) {
      throw new ApiTimeoutError(endpoint, timeoutMs);
    }
    throw error;
  }
};
